/* eslint-disable import/no-cycle */
import React, { useEffect, useLayoutEffect, useState } from 'react';

import PropTypes from 'prop-types';

import {
  FileHistoryExpandedRowDetails as FileHistoryExpandedRowDetailsPeople
} from 'ui/components/PeopleHistory/FileHistoryExpandedRowDetails';
import {
  FileHistoryExpandedRowDetails as FileHistoryExpandedRowDetailsLead
} from 'ui/components/LeadHistory/FileHistoryExpandedRowDetails';

import { Seperator } from 'ui/components/PeopleHistory/style';

import { Cell } from './cell';
import { AccordionTextCell } from './CellTypes';
import { AccordionRow, AccordionWrapper, Row } from './style';

export const Body = ({
  data,
  headerColumns,
  columnWidths,
  setHovered,
  addSelection,
  checked,
  selection,
  onToggleRow,
  onDeleteRow,
  onDownloadFile,
  downloadable,
  hovered,
  detailhover,
  onResendEmailAction,
  isRowExpandable,
  onExpandRow,
  expandedRowData,
  rowDivider,
  onIconClick,
  variant,
  pushUrl,
  onClick,
  selectedHoverRow,
  corporate,
  size,
  onPeople,
  selectedStatus,
  onStatusClick,
  isLeadsList,
  role
}) => {
  const [showRowDetail, setshowRowDetail] = useState(false);
  const [selectedFileName, setselectedFileName] = useState('');

  const [fileRowData, setFileRowData] = useState(expandedRowData);

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [accordions, setAccordions] = useState([]);

  const toggleAccordion = index => {
    if (accordions[index] !== index) {
      setIsAccordionOpen(false);
      setAccordions([]);
    }
    setAccordions([index]);
    setIsAccordionOpen(!isAccordionOpen);
  };

  useEffect(() => {
    setFileRowData(expandedRowData);
  }, [expandedRowData]);

  const handleRowDetail = filename => {
    if (selectedFileName !== filename) {
      setFileRowData([]);
      onExpandRow(filename);
      setselectedFileName(filename);
      setshowRowDetail(true);
    } else {
      setselectedFileName('');
      setshowRowDetail(false);
    }
  };

  useLayoutEffect(() => {
    if (selectedHoverRow) {
      const row = data.find(r => selectedHoverRow(r));
      if (row) {
        const highlightedRow = document.querySelector(
          `[value='${row.eventId || row.sessionId}']`
        );

        if (highlightedRow) {
          highlightedRow.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
  }, [data, selectedHoverRow]);
  return data?.map((rowData, index) => (
    <React.Fragment key={index}>
      <Row
        key={index}
        columns={headerColumns?.length}
        columnWidths={columnWidths}
        onMouseMove={() => {
          selection && setHovered({ ...rowData, index });
        }}
        checked={selection && checked.includes(index)}
        onMouseLeave={() => {
          selection && setHovered(null);
        }}
        detailhover={detailhover}
        selection={selection}
        hasAccordion={isAccordionOpen && accordions?.includes(index)}
        selectedHovered={selectedHoverRow ? selectedHoverRow(rowData) : false}
      >
        {headerColumns.map((col, colIndex) => (
          <Cell
            key={colIndex}
            colIndex={colIndex}
            rowIndex={index}
            cellData={col}
            rowData={rowData}
            checked={checked}
            selection={selection}
            onToggleRow={onToggleRow}
            onDeleteRow={onDeleteRow}
            onToggleAccordion={toggleAccordion}
            onDownloadFile={onDownloadFile}
            downloadable={downloadable}
            hovered={hovered}
            onResendEmailAction={onResendEmailAction}
            onIconClick={onIconClick}
            pushUrl={pushUrl}
            onClickCheck={() => {
              if (selection) {
                addSelection(rowData, index);
              }
            }}
            onTextClick={event => {
              if (onClick) onClick(event, rowData);
            }}
            hasAccordion={rowData.connectors?.length > 0}
            corporate={corporate}
            size={size}
            onPeople={onPeople}
            isLeadsList={isLeadsList}
            selectedStatus={selectedStatus}
            onStatusClick={onStatusClick}
            role={role}
          />
        ))}
      </Row>
      {isAccordionOpen &&
        accordions.includes(index) &&
        rowData.connectors
          .filter(conn => conn.connectorId !== '0')
          .map((connector, i) => (
            <AccordionWrapper key={i}>
              <AccordionRow>
                <AccordionTextCell>
                  Connector {connector.connectorId}
                </AccordionTextCell>
                <AccordionTextCell type="status" value={connector.status}>
                  {connector.status}
                </AccordionTextCell>
              </AccordionRow>
            </AccordionWrapper>
          ))}
      {isRowExpandable && variant === 'fileHistoryPeople' && (
        <FileHistoryExpandedRowDetailsPeople
          rowData={rowData}
          handleRowDetail={handleRowDetail}
          onExpandRow={onExpandRow}
          showRowDetail={showRowDetail}
          fileRowData={fileRowData}
          selectedFileName={selectedFileName}
        />
      )}
      {isRowExpandable && variant === 'fileHistoryPeopleLeads' && (
        <FileHistoryExpandedRowDetailsLead
          rowData={rowData}
          handleRowDetail={handleRowDetail}
          onExpandRow={onExpandRow}
          showRowDetail={showRowDetail}
          fileRowData={fileRowData}
          selectedFileName={selectedFileName}
        />
      )}
      {rowDivider && index !== data?.length - 1 && <Seperator header />}
    </React.Fragment>
  ));
};

Body.propTypes = {
  data: PropTypes.array,
  headerColumns: PropTypes.array,
  columnWidths: PropTypes.string,
  setSelected: PropTypes.func,
  addSelection: PropTypes.func,
  checked: PropTypes.array,
  selection: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  onToggleRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onDownloadFile: PropTypes.func,
  downloadable: PropTypes.bool,
  detailhover: PropTypes.bool,
  onEmailClick: PropTypes.func,
  setWasEmailClicked: PropTypes.func,
  corporate: PropTypes.bool,
  size: PropTypes.number,
  onStatusClick: PropTypes.func,
  isLeadsList: PropTypes.bool,
  role: PropTypes.string
};
